export default {
  sampleData: state => state.sampleData,
};
